import { render } from "./Privileges.vue?vue&type=template&id=2d78d085&scoped=true"
import script from "./Privileges.vue?vue&type=script&lang=js"
export * from "./Privileges.vue?vue&type=script&lang=js"

import "./Privileges.vue?vue&type=style&index=0&id=2d78d085&scoped=true&lang=css"
import "./Privileges.vue?vue&type=style&index=1&id=2d78d085&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d78d085"]])

export default __exports__